import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import { Link } from "react-router-dom";
import FloatingIcons from "./components/FloatingIcons";

const Blogs = () => {
  const [articles, setArticles] = useState([]);
  const [filter, setFilter] = useState("الكل");

  useEffect(() => {
    const unsubscribe = db
      .collection("articles")
      .orderBy("createdAt", "desc")
      .onSnapshot((snapshot) => {
        setArticles(
          snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
        );
      });

    return () => unsubscribe();
  }, []);

  const sections = ["الكل", "مدني", "جنائي", "إداري", "تجاري"];

  const filteredArticles =
    filter === "الكل"
      ? articles
      : articles.filter((article) => article.section === filter);

  return (
    <>
      <Nav />
      <FloatingIcons />

      <div className="blog">
        <div className="container">
          {/* العنوان */}
          <div className="mainTitle">
            <img
              src="https://res.cloudinary.com/defcamc5x/image/upload/v1755565470/lwvxfu6qtc7hmzthdt7r.png"
              alt=""
            />
            <h2>جميع المقالات</h2>
            <img
              src="https://res.cloudinary.com/defcamc5x/image/upload/v1755565520/goohmpytdhcsfw3slwup.png"
              alt=""
            />
          </div>

          {/* الفلاتر */}
          <div className="filters">
            {sections.map((sec) => (
              <button
                key={sec}
                onClick={() => setFilter(sec)}
                className={`filter-btn ${filter === sec ? "active" : ""}`}
              >
                {sec}
              </button>
            ))}
          </div>

          {/* المقالات */}
          <div className="boxs">
            {filteredArticles.length > 0 ? (
              filteredArticles.map((article) => (
                <div key={article.id} className="box">
                  <img src={article.imageUrl} alt={article.title} />
                  <div className="content">
                    <h3>{article.title}</h3>
                    <Link to={`/article/${article.id}`}>
                      <button className="read-btn">عرض المقالة</button>
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <p className="no-articles">لا توجد مقالات حالياً في هذا القسم</p>
            )}
          </div>
        </div>
      </div>

      <Footer />

      {/* ✅ CSS */}
      <style>{`
        .blog {
          padding-top:120px;
          background: #f9fafb;
          font-family: "Cairo", sans-serif;
        }

        .container {
          width: 90%;
          max-width: 1100px;
          margin: 0 auto;
        }

        /* العنوان */
        .mainTitle {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 12px;
          margin-bottom: 40px;
          flex-wrap: wrap;
        }

        .mainTitle img {
          height: 35px;
        }

        .mainTitle h2 {
          font-size: 2rem;
          color: #1e3a1e;
          font-weight: 700;
          text-align: center;
        }

        /* الفلاتر */
        .filters {
          text-align: center;
          margin: 20px 0 40px;
          flex-wrap: wrap;
        }

        .filter-btn {
          margin: 8px;
          padding: 10px 22px;
          border-radius: 30px;
          border: 1px solid #ccc;
          background: #fff;
          color: #333;
          cursor: pointer;
          font-weight: 600;
          transition: 0.3s;
          font-size: 15px;
        }

        .filter-btn:hover {
          background: #eaf1ea;
        }

        .filter-btn.active {
          background: #29521e;
          color: #fff;
          border: 2px solid #29521e;
        }

        /* البوكسات */
        .boxs {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(270px, 1fr));
          gap: 25px;
        }

        .box {
          background: #fff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          display: flex;
          flex-direction: column;
        }

        .box:hover {
          transform: translateY(-6px);
          box-shadow: 0 8px 25px rgba(0,0,0,0.12);
        }

        .box img {
          width: 100%;
          height: 200px;
          object-fit: cover;
        }

        .content {
          padding: 20px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .content h3 {
          font-size: 1.1rem;
          font-weight: 700;
          color: #222;
          margin-bottom: 15px;
          line-height: 1.5;
        }

        .read-btn {
          background: #29521e;
          color: #fff;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-weight: 600;
          transition: 0.3s;
          align-self: flex-start;
        }

        .read-btn:hover {
          background: #3a7a2b;
        }

        .no-articles {
          text-align: center;
          width: 100%;
          color: #666;
          font-size: 1rem;
        }

        /* ✅ Responsive */
        @media (max-width: 768px) {
          .mainTitle h2 {
            font-size: 1.6rem;
          }

          .filter-btn {
            padding: 8px 16px;
            font-size: 14px;
          }

          .box img {
            height: 180px;
          }
        }

        @media (max-width: 480px) {
          .blog {
            padding: 100px 10px 60px;
            padding-top:150px;
          }

          .mainTitle h2 {
            font-size: 1.4rem;
          }

          .filter-btn {
            padding: 8px 14px;
            font-size: 13px;
          }

          .boxs {
            gap: 18px;
          }

          .content h3 {
            font-size: 1rem;
          }

          .read-btn {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>
    </>
  );
};

export default Blogs;
